import React from 'react';

function About () {
	return <div>
		<h2>PlogCastly.soft-wa.re is a personal project</h2>
        <p>
            I want to increase your reach!
		</p>
		<a  className="App-link"
            href="https://github.com/Soft-wa-re/BlogToPodcast">
            Learn more on our github page!
		</a>
	</div>
}
export default About;
